import styled from "styled-components";
import IcCheckOn from "../../../resources/images/icon/checkbox/checkbox_select.svg";

export const OpacityBg = styled.div`
  top: 0px;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.4000000059604645;
  background: #000;
`;

export const ModalBody = styled.div`
  display: flex;
  padding: 24px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  border-radius: 10px;
  background: #fff;
  margin: 20px;

  width: calc(100% - 64px);
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`;

export const HeaderText = styled.div`
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 125% */
  letter-spacing: 0.16px;
  text-align: center;

  display: flex;
  flex-wrap: wrap-reverse;
  flex-direction: column;
  gap: 8px;
`;

export const HeaderDescDiv = styled.div`
  text-align: center;

  color: #999;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ContentsBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const ContentHeader = styled.div`
  display: flex;
  padding: 0px 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const HeaderTextBlack = styled.div`
  color: #333;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const HeaderTextBlue = styled.div`
  color: #6a62e6;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px; /* 100% */
  letter-spacing: 0.12px;
`;

export const DivToGray = styled.div`
  display: flex;
  padding: 16px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 10px;
  background: #fafafa;
`;

export const DivInText = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const TextNum = styled.div`
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.12px;
`;

export const Text = styled.div`
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.12px;

  /* flex: 1 0 0; */
`;

export const BottomBtnArea = styled.div`
  display: flex;
  padding: 0px 4px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const Checkbox = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  color: #666;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 100% */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export const CheckIcon = styled.input`
  appearance: none !important;
  display: flex;
  width: 16px;
  height: 16px;
  align-items: flex-start;
  border-radius: 2px;
  border: 1px solid #ddd;
  background: ${(props) => (props.toggle ? "#000" : "#fff")};
  color: #fff;
  justify-content: center;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% !important;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

export const BtnRound = styled.div`
  display: flex;
  padding: 16px 32px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 23px;
  background: #6b65de;

  color: #fff;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px; /* 100% */
`;

export const GrayArrowTextArea = styled.textarea`
  resize: none;
  border: 0px;
  background: #fafafa;
  font-family: pretendard;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const PostScriptDiv = styled.div`
  color: #999;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  flex: 1 0 0;
  margin-top: 8px;
`;

export const LinkText = styled.p`
  color: #06f;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "dlig" on;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  text-decoration-line: underline;
`;
